export const CONTRACTUAL_TYPES = {
    overdraft: "overdraft",
}